import {AppTooltip} from "app/@components";
import {IconButtonSeeker} from "ui-seeker/core";
import * as React from "react";

export default function AppActionButton ({ onClick, icon, label, placement = "top", className = "", color, iconWeight= "fal", ...props }) {
    return <AppTooltip title={label} placement={placement}>
        <IconButtonSeeker onClick={onClick} icon={icon} iconType="fontAwesome" className={`btn-play-report ${className} ${color && "app-btn-"+color}`} iconWeight={iconWeight} {...props} />
    </AppTooltip>
}